import React, { useState, useEffect } from "react"
import { CardBody, Container, Row, Col, Card, Button } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { ToastContainer, toast } from "react-toastify"
import logo from "../../assets/images/logo.png"
import { useHistory } from "react-router-dom"
import { URLS } from "../../Url"
import axios from "axios"

function Store() {
  const history = useHistory()
  const [seller, setSeller] = useState(null)
  const [sellers, setSellers] = useState([])
  const [planStatus, setPlanStatus] = useState([])

  console.log(planStatus)

  const GetAuth = localStorage.getItem("authUser")
  const TokenJson = JSON.parse(GetAuth || "{}")
  const TokenData = TokenJson?.token

  // Subscription state
  const [subscriber, setSubscriber] = useState([])
  const [subscription, setSubscription] = useState(null)
  const [subscriptions, setSubscriptions] = useState(null)
  const [loading, setLoading] = useState({
    subscriber: false,
    currentPlan: false,
    seller: false,
    plan: false,
  })
  const [error, setError] = useState({
    subscriber: null,
    currentPlan: null,
    seller: null,
    plan: null,
  })

  const authData = JSON.parse(localStorage.getItem("authUser") || "{}")
  const vendorDetails = authData?.vendor || {}

  useEffect(() => {
    getSubscriber()
    getCurrentplan()
    getSellers()
    showPopup()
    getPlan()
  }, [])

  const getSubscriber = async () => {
    try {
      setLoading(prev => ({ ...prev, subscriber: true }))
      setError(prev => ({ ...prev, subscriber: null }))

      if (!TokenData) {
        throw new Error("Authentication token missing")
      }

      const response = await axios.post(
        URLS.GetSubscription,
        {},
        { headers: { Authorization: `Bearer ${TokenData}` } }
      )

      setSubscriber(response.data.subscriptions || [])
    } catch (error) {
      console.error("Error fetching Subscriber:", error)
      setError(prev => ({
        ...prev,
        subscriber: "Failed to fetch subscription plans",
      }))
    } finally {
      setLoading(prev => ({ ...prev, subscriber: false }))
    }
  }

  const getCurrentplan = async () => {
    try {
      setLoading(prev => ({ ...prev, currentPlan: true }))
      setError(prev => ({ ...prev, currentPlan: null }))

      if (!TokenData) {
        throw new Error("Authentication token missing")
      }

      const response = await axios.post(
        URLS.GetCurrentSubscription,
        {},
        { headers: { Authorization: `Bearer ${TokenData}` } }
      )

      if (response.data.subscribers && response.data.subscribers.length > 0) {
        setSubscription(response.data.subscribers[0])
        setSubscriptions(response.data)
      }
    } catch (error) {
      console.error("Error fetching current subscription:", error)
      setError(prev => ({
        ...prev,
        currentPlan: "Failed to fetch current subscription",
      }))
    } finally {
      setLoading(prev => ({ ...prev, currentPlan: false }))
    }
  }

  const handlePayment = data => {
    if (!TokenData) {
      toast.error("Authentication token missing")
      return
    }

    const processPayment = async () => {
      try {
        const paymentResponse = await axios.post(
          URLS.BuySubscription,
          {
            planId: data._id,
            transactionStatus: "completed",
            transactionId: data.price === 0 ? "free" : undefined,
            amount: data.price,
          },
          { headers: { Authorization: `Bearer ${TokenData}` } }
        )

        if (paymentResponse.status === 200) {
          toast.success(paymentResponse.data.message)
          getCurrentplan()
          getPlan()
        }
      } catch (error) {
        console.error("Payment processing error:", error)
        toast.error("Failed to process payment")
      }
    }

    if (data.price === 0) {
      processPayment()
    } else {
      const totals = parseInt(data.price) * 100
      const options = {
        key: "rzp_test_HJG5Rtuy8Xh2NB",
        amount: totals,
        currency: "INR",
        name: "Bizzmate",
        description: `Subscription for ${data.name} plan`,
        image: logo,
        handler: async function (response) {
          try {
            await processPayment()
          } catch (error) {
            console.error("Payment processing error:", error)
            toast.error("Failed to process payment")
          }
        },
        prefill: {
          name: `${vendorDetails.firstName || ""} ${
            vendorDetails.lastName || ""
          }`,
          email: vendorDetails.email || "",
          contact: vendorDetails.sellerMobile || "",
        },
        theme: {
          color: "#00578E",
        },
        modal: {
          ondismiss: function () {
            toast.info("Payment window closed")
          },
        },
      }

      const rzp1 = new window.Razorpay(options)
      rzp1.open()
    }
  }

  const formatDate = dateString => {
    if (!dateString) return "N/A"
    try {
      const options = { year: "numeric", month: "long", day: "numeric" }
      return new Date(dateString).toLocaleDateString(undefined, options)
    } catch (error) {
      console.error("Error formatting date:", error)
      return "Invalid date"
    }
  }

  const getSellers = async () => {
    if (!TokenData) {
      toast.error("Authentication token not found")
      return
    }

    try {
      setLoading(prev => ({ ...prev, seller: true }))
      setError(prev => ({ ...prev, seller: null }))

      const response = await axios.post(
        URLS.GetStore,
        {},
        {
          headers: { Authorization: `Bearer ${TokenData}` },
        }
      )

      const sellerData = response?.data?.data || []
      setSellers(sellerData)
      setSeller(sellerData[0] || null)
    } catch (error) {
      console.error("Error fetching sellers:", error)
      setError(prev => ({ ...prev, seller: "Failed to fetch seller data" }))
    } finally {
      setLoading(prev => ({ ...prev, seller: false }))
    }
  }

  const editSeller = data => {
    if (!data?._id) {
      toast.error("Invalid seller data")
      return
    }
    sessionStorage.setItem("Sellerid", data._id)
    history.push("/EditSeller")
  }

  const showPopup = () => {
    const toastMessage = sessionStorage.getItem("tost")
    if (toastMessage) {
      toast(toastMessage)
      sessionStorage.removeItem("tost")
    }
  }

  const renderMultipleValues = (values, separator = ", ") => {
    if (!values) return "-"
    if (Array.isArray(values)) {
      return values.length > 0 ? values.join(separator) : "-"
    }
    return values || "-"
  }

  const getPlan = async () => {
    if (!TokenData) {
      toast.error("Authentication token not found")
      return
    }

    try {
      setLoading(prev => ({ ...prev, plan: true }))
      setError(prev => ({ ...prev, plan: null }))

      const response = await axios.post(
        URLS.GetSubscriptionPopUp,
        {},
        {
          headers: { Authorization: `Bearer ${TokenData}` },
        }
      )
      setPlanStatus(response?.data?.planStatus || false)
      if (response?.data?.planStatus == false) {
        setLoading(prev => ({ ...prev, plan: true }))
      }
    } catch (error) {
      console.error("Error fetching Plans:", error)
      setError(prev => ({ ...prev, plan: "Failed to fetch plan status" }))
    } finally {
      setLoading(prev => ({ ...prev, plan: false }))
    }
  }

  const handleAddStore = () => {
    if (planStatus === true) {
      history.push("/AddSeller")
    } else {
      toast.error("Please subscribe to a plan first")
    }
  }

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Bizzmate Supplier" breadcrumbItem="Bizz Profile" />

        {loading.seller ? (
          <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-2">Loading store information...</p>
          </div>
        ) : error.seller ? (
          <div className="alert alert-danger text-center">
            {error.seller}
            <button className="btn btn-link p-0 ms-2" onClick={getSellers}>
              Retry
            </button>
          </div>
        ) : seller ? (
          <Card>
            <CardBody>
              <Row>
                <Col>
                  {loading.seller ? (
                    <Button
                      className="mb-3 m-1"
                      style={{ float: "right" }}
                      disabled
                    >
                      <i className="bx bx-loader bx-spin"></i> Loading...
                    </Button>
                  ) : sellers.length === 0 ? (
                    <Button
                      className="mb-3 m-1"
                      style={{ float: "right" }}
                      color="primary"
                      onClick={handleAddStore}
                      disabled={loading.plan}
                      size="sm"
                    >
                      <i className="bx bx-plus"></i> Add Store
                    </Button>
                  ) : (
                    <Button
                      onClick={() => editSeller(seller)}
                      className="mb-3 m-1"
                      style={{ float: "right" }}
                      color="primary"
                      disabled={!seller}
                      size="sm"
                    >
                      <i className="bx bx-edit"></i> Edit Store
                    </Button>
                  )}
                </Col>
              </Row>
              <Row>
                <Col lg={4} className="mb-4">
                  <h5 className="mt-2 text-primary">Biz Registration :-</h5>
                  <ul className="list-unstyled vstack gap-3 mb-0">
                    <li>
                      <div className="d-flex mt-3">
                        <i className="bx bx-user font-size-18 text-primary"></i>
                        <div className="ms-3">
                          <h6 className="mb-1 fw-semibold">Store Profile:</h6>
                          {seller.storeProfile ? (
                            <img
                              src={`${URLS.Base}${seller.storeProfile}`}
                              alt="Store Profile"
                              style={{ height: "100px" }}
                            />
                          ) : (
                            <span className="text-muted">-</span>
                          )}
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="d-flex mt-3">
                        <i className="bx bx-user font-size-18 text-primary"></i>
                        <div className="ms-3">
                          <h6 className="mb-1 fw-semibold">Store Name:</h6>
                          <span className="text-muted">
                            {seller.storeName || "-"}
                          </span>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="d-flex mt-3">
                        <i className="bx bx-phone font-size-18 text-primary"></i>
                        <div className="ms-3">
                          <h6 className="mb-1 fw-semibold">Store Phone:</h6>
                          <span className="text-muted">
                            {seller.storePhone || "-"}
                          </span>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="d-flex mt-3">
                        <i className="bx bx-message-rounded font-size-18 text-primary"></i>
                        <div className="ms-3">
                          <h6 className="mb-1 fw-semibold">Store Email:</h6>
                          <span className="text-muted">
                            {seller.storeEmail || "-"}
                          </span>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="d-flex mt-3">
                        <i className="bx bx-message-rounded font-size-18 text-primary"></i>
                        <div className="ms-3">
                          <h6 className="mb-1 fw-semibold">Gst Number:</h6>
                          <span className="text-muted">
                            {seller.gst || "-"}
                          </span>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="d-flex mt-3">
                        <i className="bx bx-message-rounded font-size-18 text-primary"></i>
                        <div className="ms-3">
                          <h6 className="mb-1 fw-semibold">Store Status:</h6>
                          <span>
                            {renderMultipleValues(seller.storestatus)}
                          </span>
                        </div>
                      </div>
                    </li>
                  </ul>
                </Col>
                <Col lg={4} className="mb-4">
                  <h6 className="mb-4 text-primary">Bizz Address :-</h6>
                  <ul className="verti-timeline list-unstyled">
                    <li className="event-list">
                      <div className="event-timeline-dot">
                        <i className="bx bx-right-arrow-circle"></i>
                      </div>
                      <div className="d-flex">
                        <div className="flex-grow-1">
                          <div>
                            <h6 className="font-size-14 mb-1">Store Country</h6>
                            <span className="text-muted">
                              {seller.countryName || "-"}
                            </span>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li className="event-list">
                      <div className="event-timeline-dot">
                        <i className="bx bx-right-arrow-circle"></i>
                      </div>
                      <div className="d-flex">
                        <div className="flex-grow-1">
                          <div>
                            <h6 className="font-size-14 mb-1">Store State</h6>
                            <span className="text-muted">
                              {seller.stateName || "-"}
                            </span>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li className="event-list">
                      <div className="event-timeline-dot">
                        <i className="bx bx-right-arrow-circle"></i>
                      </div>
                      <div className="d-flex">
                        <div className="flex-grow-1">
                          <div>
                            <h6 className="font-size-14 mb-1">
                              Store District{" "}
                            </h6>
                            <span className="text-muted">
                              {seller.districtName || "-"}
                            </span>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li className="event-list">
                      <div className="event-timeline-dot">
                        <i className="bx bx-right-arrow-circle"></i>
                      </div>
                      <div className="d-flex">
                        <div className="flex-grow-1">
                          <div>
                            <h6 className="font-size-14 mb-1">Store Pincode</h6>
                            <span className="text-muted">
                              {seller.storePincode || "-"}
                            </span>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li className="event-list">
                      <div className="event-timeline-dot">
                        <i className="bx bx-right-arrow-circle"></i>
                      </div>
                      <div className="d-flex">
                        <div className="flex-grow-1">
                          <div>
                            <h6 className="font-size-14 mb-1">Address 1</h6>
                            <span className="text-muted">
                              {seller.storeAddressOne || "-"}
                            </span>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li className="event-list">
                      <div className="event-timeline-dot">
                        <i className="bx bx-right-arrow-circle"></i>
                      </div>
                      <div className="d-flex">
                        <div className="flex-grow-1">
                          <div>
                            <h6 className="font-size-14 mb-1">Address 2</h6>
                            <span className="text-muted">
                              {seller.storeAddressTwo || "-"}
                            </span>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </Col>
                <Col lg={4} className="mb-4">
                  <h6 className="mb-4 text-primary">
                    Biz Locations / Delivery Type / Receipt Mode :-
                  </h6>
                  <ul className="verti-timeline list-unstyled">
                    {(seller.businessLevel === "Country" ||
                      seller.businessLevel === "State" ||
                      seller.businessLevel === "District" ||
                      seller.businessLevel === "Pincode") && (
                      <li className="event-list">
                        <div className="event-timeline-dot">
                          <i className="bx bx-right-arrow-circle"></i>
                        </div>
                        <div className="d-flex">
                          <div className="flex-grow-1">
                            <div>
                              <h6 className="font-size-14 mb-1">
                                Delivery Countries
                              </h6>
                              <span className="text-muted">
                                {renderMultipleValues(
                                  seller.deliveryCountryNames
                                )}
                              </span>
                            </div>
                          </div>
                        </div>
                      </li>
                    )}
                    {(seller.businessLevel === "State" ||
                      seller.businessLevel === "District" ||
                      seller.businessLevel === "Pincode") && (
                      <li className="event-list">
                        <div className="event-timeline-dot">
                          <i className="bx bx-right-arrow-circle"></i>
                        </div>
                        <div className="d-flex">
                          <div className="flex-grow-1">
                            <div>
                              <h6 className="font-size-14 mb-1">
                                Delivery States
                              </h6>
                              <span className="text-muted">
                                {renderMultipleValues(
                                  seller.deliveryStateNames
                                )}
                              </span>
                            </div>
                          </div>
                        </div>
                      </li>
                    )}
                    {(seller.businessLevel === "District" ||
                      seller.businessLevel === "Pincode") && (
                      <li className="event-list">
                        <div className="event-timeline-dot">
                          <i className="bx bx-right-arrow-circle"></i>
                        </div>
                        <div className="d-flex">
                          <div className="flex-grow-1">
                            <div>
                              <h6 className="font-size-14 mb-1">
                                Delivery Districts
                              </h6>
                              <span className="text-muted">
                                {renderMultipleValues(
                                  seller.deliveryDistrictNames
                                )}
                              </span>
                            </div>
                          </div>
                        </div>
                      </li>
                    )}
                    {seller.businessLevel === "Pincode" && (
                      <li className="event-list">
                        <div className="event-timeline-dot">
                          <i className="bx bx-right-arrow-circle"></i>
                        </div>
                        <div className="d-flex">
                          <div className="flex-grow-1">
                            <div>
                              <h6 className="font-size-14 mb-1">
                                Delivery Pincode
                              </h6>
                              <span className="text-muted">
                                {renderMultipleValues(seller.deliveryPincodes)}
                              </span>
                            </div>
                          </div>
                        </div>
                      </li>
                    )}
                    <li className="event-list">
                      <div className="event-timeline-dot">
                        <i className="bx bx-right-arrow-circle"></i>
                      </div>
                      <div className="d-flex">
                        <div className="flex-grow-1">
                          <div>
                            <h6 className="font-size-14 mb-1">Delivery Type</h6>
                            <span className="text-muted">
                              {renderMultipleValues(seller.deliveryTypeNames)}
                            </span>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li className="event-list">
                      <div className="event-timeline-dot">
                        <i className="bx bx-right-arrow-circle"></i>
                      </div>
                      <div className="d-flex">
                        <div className="flex-grow-1">
                          <div>
                            <h6 className="font-size-14 mb-1">Receipt Mode</h6>
                            <span className="text-muted">
                              {renderMultipleValues(seller.receiptMode)}
                            </span>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li className="event-list">
                      <div className="event-timeline-dot">
                        <i className="bx bx-right-arrow-circle"></i>
                      </div>
                      <div className="d-flex">
                        <div className="flex-grow-1">
                          <div>
                            <h6 className="font-size-14 mb-1">
                              kyc Verification
                            </h6>
                            <span className="text-muted">
                              {renderMultipleValues(seller.kycVerification)}
                            </span>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li className="event-list">
                      <div className="event-timeline-dot">
                        <i className="bx bx-right-arrow-circle"></i>
                      </div>
                      <div className="d-flex">
                        <div className="flex-grow-1">
                          <div>
                            <h6 className="font-size-14 mb-1">
                              kyc Rejected Reason
                            </h6>
                            <span className="text-muted">
                              {renderMultipleValues(seller.kycRejectedReason)}
                            </span>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </Col>
                <hr></hr>
                <Col md={12} className="mt-4">
                  <Row>
                    <Col md={4}>
                      <ul className="verti-timeline list-unstyled">
                        <li className="event-list">
                          <div className="event-timeline-dot">
                            <i className="bx bx-right-arrow-circle"></i>
                          </div>
                          <div className="d-flex">
                            <div className="flex-grow-1">
                              <div>
                                <h6 className="font-size-14 mb-1">
                                  Store Banner
                                </h6>
                                <span className="text-muted">
                                  {seller.storeBanner ? (
                                    <img
                                      src={`${URLS.Base}${seller.storeBanner}`}
                                      alt="Store Banner"
                                      style={{
                                        height: "100px",
                                      }}
                                    />
                                  ) : (
                                    <span className="text-muted">-</span>
                                  )}
                                </span>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </Col>
                    <Col md={6}>
                      <ul className="verti-timeline list-unstyled">
                        <li className="event-list">
                          <div className="event-timeline-dot">
                            <i className="bx bx-right-arrow-circle"></i>
                          </div>
                          <div className="d-flex">
                            <div className="flex-grow-1">
                              <div>
                                <h6 className="font-size-14 mb-1">
                                  Gst Document
                                </h6>
                                <span className="text-muted">
                                  {seller.gstImage ? (
                                    <img
                                      src={`${URLS.Base}${seller.gstImage}`}
                                      alt="GST Document"
                                      style={{
                                        height: "100px",
                                      }}
                                    />
                                  ) : (
                                    <span className="text-muted">-</span>
                                  )}
                                </span>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </CardBody>
          </Card>
        ) : (
          <>
            {loading.currentPlan ? (
              <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p className="mt-2">Loading your subscription details...</p>
              </div>
            ) : error.currentPlan ? (
              <div className="alert alert-danger text-center">
                {error.currentPlan}
                <button
                  className="btn btn-link p-0 ms-2"
                  onClick={getCurrentplan}
                >
                  Retry
                </button>
              </div>
            ) : subscription ? (
              <div className="row justify-content-center">
                <div className="col-lg-10">
                  <div className="card subscription-card">
                    <div className="card-body">
                      <div className="text-center mb-4">
                        <h3 className="card-title">My Subscription Plan</h3>
                        <p className="text-muted">
                          View your current subscription details
                        </p>
                      </div>
                      <div className="subscription-details">
                        <div className="row">
                          <div className="col-md-6">
                            <div className="mb-4">
                              <h5 className="section-title">Plan Details</h5>
                              <div className="p-3 bg-light rounded-3">
                                <div className="d-flex justify-content-between mb-2">
                                  <span className="text-muted">Plan Name:</span>
                                  <span className="fw-medium">
                                    {subscription.planName || "N/A"}
                                  </span>
                                </div>
                                <div className="d-flex justify-content-between mb-2">
                                  <span className="text-muted">Duration:</span>
                                  <span className="fw-medium">
                                    {subscription.duration || "N/A"}
                                  </span>
                                </div>
                                <div className="d-flex justify-content-between mb-2">
                                  <span className="text-muted">Amount:</span>
                                  <span className="fw-medium">
                                    ₹{subscription.amount || "0"}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-4">
                              <h5 className="section-title">Payment Details</h5>
                              <div className="p-3 bg-light rounded-3">
                                <div className="d-flex justify-content-between mb-2">
                                  <span className="text-muted">
                                    Payment Status:
                                  </span>
                                  <span
                                    className={`text-${
                                      subscription.paymentStatus === "completed"
                                        ? "success"
                                        : "warning"
                                    }`}
                                  >
                                    {subscription.paymentStatus || "pending"}
                                  </span>
                                </div>
                                <div className="d-flex justify-content-between mb-2">
                                  <span className="text-muted">
                                    Transaction ID:
                                  </span>
                                  <span
                                    className="fw-medium text-truncate"
                                    style={{ maxWidth: "150px" }}
                                  >
                                    {subscription.transactionId || "N/A"}
                                  </span>
                                </div>
                                <div className="d-flex justify-content-between mb-2">
                                  <span className="text-muted">
                                    Payment Date:
                                  </span>
                                  <span className="fw-medium">
                                    {formatDate(subscription.logCreatedDate)}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-12">
                            <div className="mb-4">
                              <h5 className="section-title">
                                Subscription Status
                              </h5>
                              <div className="p-3 bg-light rounded-3">
                                <div className="row align-items-center">
                                  <div className="col-md-4 mb-3 mb-md-0">
                                    <span className="d-block text-muted mb-1">
                                      Status:
                                    </span>
                                    <span
                                      className={`text-${
                                        subscription.status === "active"
                                          ? "success"
                                          : "danger"
                                      } fs-6`}
                                    >
                                      {subscription.status || "inactive"}
                                    </span>
                                  </div>
                                  <div className="col-md-4 mb-3 mb-md-0">
                                    <span className="d-block text-muted mb-1">
                                      Plan Duration:
                                    </span>
                                    <span className="fw-medium">
                                      {subscriptions.duration}
                                    </span>
                                  </div>
                                  <div className="col-md-4">
                                    <span className="d-block text-muted mb-1">
                                      Days Remaining:
                                    </span>
                                    <span className="fw-medium">
                                      {subscriptions.remainingDaysLeft} days
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="text-center mt-4">
                          <button
                            className="btn btn-primary"
                            onClick={() => handleAddStore()}
                          >
                            Add Store
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <>
                <div className="row justify-content-center mt-4">
                  <div className="col-lg-8 text-center">
                    <h2 className="mb-3">Choose Your Pricing Plan</h2>
                    <p className="text-muted mb-5">
                      Select the plan that best fits your business needs
                    </p>
                  </div>
                </div>
                {loading.subscriber ? (
                  <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-2">Loading available plans...</p>
                  </div>
                ) : error.subscriber ? (
                  <div className="alert alert-danger text-center">
                    {error.subscriber}
                    <button
                      className="btn btn-link p-0 ms-2"
                      onClick={getSubscriber}
                    >
                      Retry
                    </button>
                  </div>
                ) : (
                  <div className="row justify-content-center mb-5">
                    {subscriber.map((data, i) => (
                      <div className="col-md-3 col-xl-3 mb-4" key={i}>
                        <div
                          className={`plan-card card h-100 ${
                            i % 2 === 0 ? "border-primary" : "border-success"
                          }`}
                        >
                          <div className="card-body d-flex flex-column">
                            <div className="d-flex align-items-center mb-4">
                              <div className="flex-grow-1">
                                <h4 className="plan-name">{data.name}</h4>
                                <p className="text-muted plan-description">
                                  {data.description}
                                </p>
                              </div>
                              {data.image && (
                                <div className="flex-shrink-0 ms-3">
                                  <img
                                    src={`${URLS.Base}${data.image}`}
                                    alt={data.name}
                                    className="img-fluid plan-image"
                                    style={{ width: "60px" }}
                                  />
                                </div>
                              )}
                            </div>
                            <div className="text-center py-3">
                              <h2 className="plan-price">
                                <sup>
                                  <small>₹</small>
                                </sup>
                                {data.price}
                                <span className="font-size-16 text-muted">
                                  / {data.duration}
                                </span>
                              </h2>
                            </div>
                            <div className="plan-features mt-3 mb-4 flex-grow-1">
                              {data?.benefits?.map((datas, k) => (
                                <div
                                  className="d-flex align-items-start mb-2"
                                  key={k}
                                >
                                  <i className="bx bx-check text-success mt-1 me-2" />
                                  <span>{datas?.benefits}</span>
                                </div>
                              ))}
                            </div>
                            <div className="text-center mt-auto">
                              <button
                                className="btn btn-primary w-100"
                                onClick={() => handlePayment(data)}
                              >
                                Subscribe Now
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </>
            )}
          </>
        )}
      </Container>
      <ToastContainer />
    </div>
  )
}

export default Store
